<template>
    <div
        class="group my-4 rounded-lg border-iron-200 bg-white px-4 py-5 shadow-sm hover:shadow-md w-full border transition-all duration-200"
    >
        <div class="space-x-3 sm:flex items-center justify-between">
            <div class="gap-2 flex items-center">
                <div class="flex-shrink-0"></div>
                <div class="min-w-0 gap-3 flex">
                    <p class="font-medium text-iron-900">
                        {{ domain.name }}
                    </p>

                    <Badge v-if="domain.verified" variant="success">
                        {{ $t("domains.verified") }}
                    </Badge>
                    <Badge v-if="!domain.verified" variant="destructive">
                        {{ $t("domains.not_verified") }}
                    </Badge>

                    <Badge
                        v-if="domain.verified && !domain.dkim"
                        variant="destructive"
                    >
                        {{ $t("domains.dkim_not_verified") }}
                    </Badge>

                    <!-- <span
            class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-iron-900 ring-1 ring-inset ring-iron-200"
          >
            <svg
              class="h-1.5 w-1.5"
              :class="{
                'text-green-500': domain.cname,
                'text-error-500': !domain.cname,
              }"
              viewBox="0 0 6 6"
              aria-hidden="true"
            >
              <circle fill="currentColor" cx="3" cy="3" r="3" />
            </svg>
            CNAME
          </span> -->
                </div>
            </div>

            <div
                class="mt-3 sm:mt-0 flex flex-shrink-0 justify-start self-center"
            >
                <div class="gap-3 flex">
                    <Button
                        size="sm"
                        class="gap-1"
                        :disabled="loading"
                        variant="outline"
                        @click="verifyDomain"
                    >
                        <RefreshCw :stroke-width="2.0" :size="20" />
                        <span class="sm:inline-block hidden">{{
                            $t("domains.verify")
                        }}</span>
                    </Button>

                    <ShowRecordsModal :domain="domain">
                        <Button size="sm" variant="outline" class="gap-1">
                            <Logs :stroke-width="2.0" :size="20" />
                            <span class="sm:inline-block hidden">{{
                                $t("domains.records")
                            }}</span>
                        </Button>
                    </ShowRecordsModal>

                    <Button
                        size="icon"
                        class="h-9 w-9"
                        variant="outline"
                        :disabled="loading"
                        @click="deleteDomain"
                    >
                        <Trash :stroke-width="2.0" :size="20" />
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import { useI18n } from "vue-i18n";
import { Logs, RefreshCw, Trash, Trash2 } from "lucide-vue-next";
import { ref } from "vue";
import ShowRecordsModal from "./ShowRecordsModal.vue";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const { show } = useConfirm();
const { t } = useI18n();

const props = defineProps({
    domain: {
        required: true,
        type: Object,
    },
});

const loading = ref(false);

const deleteDomain = async function () {
    const result = await show({
        header: t("domains.are_you_sure"),
        message: t("domains.delete"),
        confirm: t("domains.remove"),
        cancel: t("cancel"),
    });

    if (!result) {
        return;
    }

    router.delete(
        route("app.domains.delete", {
            domain: props.domain.id,
        }),
    );
};

const verifyDomain = async function () {
    loading.value = true;

    router.post(
        route("app.domains.verify", {
            domain: props.domain.id,
        }),
        {},
        {
            preserveState: false,
            onFinish: () => {
                loading.value = false;
            },
        },
    );
};
</script>
